import { Component, inject } from '@angular/core';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';

/**
 * Contenedor de "Actividad de usuarios": un tab-group con dos listados de la
 * entidad unificada `actividad-usuario` — uno para inactividad y otro para
 * periodo de actividad. Cada tab se muestra según la acción de rol
 * correspondiente (mismo patrón que el menú de servicios técnicos).
 */
@Component({
  selector: 'app-actividad-usuarios',
  templateUrl: './actividad-usuarios.component.html',
  standalone: false,
})
export class ActividadUsuariosComponent {
  helper = inject(HelperService);
}
